<div
  class="documents-section"
  *ngIf="hasSections || loading"
  [ngClass]="variantClass"
  [style.--document-theme-color]="resolvedThemeColor || null"
>
  <div class="documents-header">
    <h2
      class="section-title"
      [ngStyle]="{ color: resolvedThemeColor || null }"
    >
      {{ headingKey | translate }}
    </h2>
  </div>

  <nz-spin
    *ngIf="loading"
    nzTip="{{ 'COMPANY_PAGE.LOADING' | translate }}"
  ></nz-spin>

  <ng-container *ngIf="!loading && hasSections">
    <nz-collapse [nzBordered]="false" class="documents-collapse">
      <nz-collapse-panel
        *ngFor="let section of sections"
        [nzHeader]="section.translatedTitle || section.title"
        [nzActive]="true"
        (nzActiveChange)="onPanelActiveChange(section.title, $event)"
      >
        <div class="documents-grid">
          <ng-container *ngFor="let file of section.files">
            <div
              class="doc-item"
              role="button"
              tabindex="0"
              (click)="onDocItemClick($event, section.title, file)"
              (keydown.enter)="onDocItemClick($event, section.title, file)"
              (keydown.space)="onDocItemClick($event, section.title, file)"
              [attr.aria-label]="'LANDING.DOCS.OPEN_DOCUMENT_ARIA' | translate"
            >
              <ng-container [ngSwitch]="getFileType(file)">
                <img
                  *ngSwitchCase="'jpg'"
                  [src]="file.url"
                  [alt]="file.fileName"
                  (click)="onImageClick(section.title, file.fileName, file.url)"
                />
                <img
                  *ngSwitchCase="'jpeg'"
                  [src]="file.url"
                  [alt]="file.fileName"
                  (click)="onImageClick(section.title, file.fileName, file.url)"
                />
                <img
                  *ngSwitchCase="'png'"
                  [src]="file.url"
                  [alt]="file.fileName"
                  (click)="onImageClick(section.title, file.fileName, file.url)"
                />
                <i
                  *ngSwitchCase="'pdf'"
                  nz-icon
                  nzType="file-pdf"
                  nzTheme="outline"
                  class="doc-icon"
                  (click)="$event.stopPropagation(); onDocItemClick($event, section.title, file)"
                ></i>
                <i
                  *ngSwitchDefault
                  nz-icon
                  nzType="file"
                  nzTheme="outline"
                  class="doc-icon"
                  (click)="$event.stopPropagation(); onDocItemClick($event, section.title, file)"
                ></i>
              </ng-container>

              <div class="doc-name">
                <ng-container [ngSwitch]="getFileType(file)">
                  <a
                    *ngSwitchCase="'pdf'"
                    [href]="file.url"
                    target="_blank"
                    rel="noopener"
                    (click)="$event.stopPropagation(); onFileClick(section.title, file.fileName)"
                  >
                    {{ file.fileName }}
                  </a>
                  <a
                    *ngSwitchCase="'jpg'"
                    [href]="file.url"
                    target="_blank"
                    rel="noopener"
                    (click)="$event.stopPropagation(); onFileClick(section.title, file.fileName)"
                  >
                    {{ file.fileName }}
                  </a>
                  <a
                    *ngSwitchCase="'jpeg'"
                    [href]="file.url"
                    target="_blank"
                    rel="noopener"
                    (click)="$event.stopPropagation(); onFileClick(section.title, file.fileName)"
                  >
                    {{ file.fileName }}
                  </a>
                  <a
                    *ngSwitchCase="'png'"
                    [href]="file.url"
                    target="_blank"
                    rel="noopener"
                    (click)="$event.stopPropagation(); onFileClick(section.title, file.fileName)"
                  >
                    {{ file.fileName }}
                  </a>
                  <a
                    *ngSwitchDefault
                    [href]="file.url"
                    download
                    (click)="$event.stopPropagation(); onFileClick(section.title, file.fileName)"
                  >
                    {{ file.fileName }}
                  </a>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </nz-collapse-panel>
    </nz-collapse>
  </ng-container>
</div>
